import {
  ContactModel,
  Conversation,
  Message,
  Participant,
  TagRefModel,
  TagValueModel,
  ContactSummary,
  TagModel,
  EmailListItem,
  EmailModel,
  MediaModel,
  FileItem,
  EstimateModel,
} from "./Types.ts";

import { get, post, del } from "./ApiClient.ts";

export async function fetchContactByIdentity(id: string, jwt: string): Promise<ContactModel> {
  return get<ContactModel>(`/api/directory/identities/${id}`, jwt);
}

export async function fetchConversationParticipants(conversationId: string, jwt: string): Promise<Participant[]> {
  return get<Participant[]>(`/api/messaging/conversations/${conversationId}/participants`, jwt);
}

export function fetchConversations(scope: string, type: string, jwt: string): Promise<Conversation[]> {
  return get<Conversation[]>(`/api/messaging/conversations?scope=${scope}&type=${type}`, jwt);
}

export async function fetchConversation(id: string, jwt: string): Promise<Conversation> {
  return get<Conversation>(`/api/messaging/conversations/${id}`, jwt);
}

export async function fetchMessages(conversationId: string, jwt: string): Promise<Message[]> {
  return get<Message[]>(`/api/messages/inbox?conversation=${conversationId}`, jwt);
}

export async function createMessage(msg: Message, jwt: string): Promise<Message> {
  const payload = {
    message: {
      content: msg.content,
      conversation: msg.conversation!,
      type: msg.type,
      previousId: msg.previousId,
    },
  };
  const { id, isError } = await post<{ id: string; isError: boolean }, typeof payload>(
    `/api/messaging/messages`,
    payload,
    jwt
  );
  return {
    ...msg,
    id,
    error: isError,
    sending: false,
  };
}

export async function fetchContactTags(contactId: string, jwt: string): Promise<TagRefModel[]> {
  return get<TagRefModel[]>(`/api/directory/contacts/${contactId}/tags`, jwt);
}

export async function createContactTag(contactId: string, value: TagRefModel, jwt: string): Promise<TagRefModel> {
  const payload = { path: value.path, source: "user" };
  const { id } = await post<{ id: string }, typeof payload>(`/api/directory/contacts/${contactId}/tags`, payload, jwt);
  return {
    id,
    path: value.path,
    source: "user",
  };
}

export async function deleteContactTag(contactId: string, tagId: string, jwt: string): Promise<void> {
  return del(`/api/directory/contacts/${contactId}/tags/${tagId}`, jwt);
}

export function fetchContacts(jwt: string): Promise<ContactModel[]> {
  return get<ContactModel[]>("/api/directory/contacts", jwt);
}

export async function fetchContactDetail(contactId: string, jwt: string): Promise<ContactModel> {
  return get<ContactModel>(`/api/directory/identities/${contactId}`, jwt);
}

interface CreateSummaryResponse {
  summary: ContactSummary;
}
export async function createContactSummary(contactId: string, jwt: string): Promise<ContactSummary> {
  const { summary } = await post<CreateSummaryResponse, {}>(`/api/directory/contacts/${contactId}/summary`, {}, jwt);
  if (!summary) {
    throw new Error("Expected summary was not returned.");
  }

  return summary;
}

export async function fetchTagValue(path: string, jwt: string): Promise<TagValueModel> {
  return get<TagValueModel>(`/api/${path}`, jwt);
}

//selects values across all scopes by name
export async function fetchTagByName(name: string, jwt: string): Promise<TagModel> {
  return get<TagModel>(`/api/tags/${name}`, jwt);
}

export async function fetchEmails(projectPath: string, jwt: string): Promise<EmailListItem[]> {
  if (projectPath) return get<EmailListItem[]>(`/api/emails/inbox?project=${projectPath}`, jwt);
  return get<EmailListItem[]>(`/api/emails/inbox`, jwt);
}

export async function fetchEmail(messageId: string, jwt: string): Promise<EmailModel> {
  return get<EmailModel>(`/api/emails/${messageId}`, jwt);
}

export async function fetchMessageTags(messageId: string, jwt: string): Promise<TagRefModel[]> {
  return get<TagRefModel[]>(`/api/messages/${messageId}/tags`, jwt);
}

export async function fetchMessageMedia(messageId: string, jwt: string): Promise<MediaModel[]> {
  return get<MediaModel[]>(`/api/messages/${messageId}/media`, jwt);
}

export async function fetchEstimate(fileId: string, jwt: string): Promise<EstimateModel> {
  return get<EstimateModel>(`/api/files/${fileId}/estimate`, jwt);
}

export async function createMessageTag(messageId: string, value: TagRefModel, jwt: string): Promise<TagRefModel> {
  const payload = { path: value.path, source: "user" };
  const { id } = await post<{ id: string }, typeof payload>(`/api/messages/${messageId}/tags`, payload, jwt);
  return {
    id,
    path: value.path,
    source: "user",
  };
}

export async function deleteMessageTag(messageId: string, tagId: string, jwt: string): Promise<void> {
  return del(`/api/messages/${messageId}/tags/${tagId}`, jwt);
}

export async function deleteConversation(conversationId: string, jwt: string): Promise<void> {
  return del(`/api/messaging/conversations/${conversationId}`, jwt);
}

export function createConversation(name: string, type: string, jwt: string): Promise<Conversation> {
  return post<Conversation, { name: string; type: string }>("/api/messaging/conversations", { name, type }, jwt);
}

export async function fetchFiles(projectPath: string, jwt: string): Promise<FileItem[]> {
  return get<FileItem[]>(`/api/files?project=${projectPath}`, jwt);
}

export async function fetchFile(fileId: string, jwt: string): Promise<FileItem> {
  return get<FileItem>(`/api/files/${fileId}`, jwt);
}

export async function deleteFile(fileId: string, jwt: string): Promise<void> {
  console.log("delete file");
  return del(`/api/files/${fileId}`, jwt);
}
